module.exports = __webpack_public_path__ + "graphics/checkout-credit-card-icon.ckh.7c48af5015cb62dd01f6b71e8ffe43d5.svg";